import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

export function AuthWrapper() {
	const { t } = useTranslation();

	return (
		<div className="relative">
			<div className="flex flex-grow flex-col justify-center bg-main-bg">
				<Outlet />
			</div>
			<div className="text-secondary roboto-regular text-base text-center py-4 border-t border-[#0000001A] border-t-1 w-full absolute bottom-0">
				{t('footerText', { year: new Date().getFullYear() })}
			</div>
		</div>
	);
}
